import { api } from "./client";

export type Invite = {
  id: string;
  code: string;
  uses: number;
  max_uses: number;
  expires_at: string | null;
  created_at: string;
  created_by_name: string | null;
  is_usable: boolean;
};

export type Account = {
  id: string;
  email: string;
  display_name: string;
  is_admin: boolean;
  created_at: string;
  last_login_at: string | null;
  application_count: number;
};

export const adminApi = {
  listUsers: () => api.get<Account[]>("/api/admin/users"),
  deleteUser: (id: string) => api.del<void>(`/api/admin/users/${id}`),
  listInvites: () => api.get<Invite[]>("/api/admin/invites"),
  createInvite: (uses: number, days: number) =>
    api.post<Invite>("/api/admin/invites", { uses, days }),
  revokeInvite: (id: string) => api.del<void>(`/api/admin/invites/${id}`),
};
